<ng-container *ngFor="let pill of pillFilters">
        <div class="pill-filter d-inline-block" [ngClass]="{ selected: selectedFiltersArray.includes( pill.key ) }"
              (click)="onFilterClick(pill)">{{ pill.name }}</div>
</ng-container>
